import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=11fd5280&scoped=true&"
import script from "./Chart.js?vue&type=script&lang=js&"
export * from "./Chart.js?vue&type=script&lang=js&"
import style0 from "./Chart.vue?vue&type=style&index=0&id=11fd5280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fd5280",
  null
  
)

export default component.exports